import { SonarTaskTemplateConfig } from '../@types';
import { createGetEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type GetSonarTaskTemplateConfigRequest = {
	organizationId: number;
	taskType: string;
	shardName?: string;
};

export type GetSonarTaskTemplateConfigResponse = SonarTaskTemplateConfig;

export const getSonarTaskTemplateConfig =
	createGetEndpoint<GetSonarTaskTemplateConfigRequest, GetSonarTaskTemplateConfigResponse>(
		(request) => `/api/v3/core/organizations/${request.organizationId}/tasks/${request.taskType}/config`,
		{
			headers: (request) => {
				if (request?.shardName) {
					return { [ HttpHeader.Shard ]: request.shardName };
				}

				return {};
			}
		}
	);
